import React, { useState, useEffect, useRef } from 'react';
import { message, Avatar, Radio, Typography, Modal, Tag, Tooltip, Row, Col, Button, Icon } from 'antd';
import { withRouter, Link } from 'react-router-dom';
import { Form, FormItem, InputNumber, Checkbox } from 'formik-antd';
import { Formik, ErrorMessage } from 'formik';
import { useMutation, useQuery } from '@apollo/react-hooks';
import {
    UPDATE_TOURNAMENT_BRACKET_MATCH_MUTATION,
    UPDATE_TOURNAMENT_SET_MUTATION,
    UPDATE_TOURNAMENT_MATCH_GAME,
    CREATE_TOURNAMENT_MATCH_GAME,
    DELETE_TOURNAMENT_MATCH_GAME,
    RESET_TOURNAMENT_MATCH_GAMES,
} from './data/mutations';
import {
    GET_TOURNAMENT_BRACKET_MATCH_QUERY,
    GET_TOURNAMENT_MATCH_SETS_QUERY,
    GET_TOURNAMENT_MATCH_GAMES_QUERY,
    GET_EVENT_LIVE_TABLE_QUERY,
} from './data/queries';
import { Query, Subscription } from '@apollo/client/react/components';
import { advanceTournamentPlayers } from '../../../utils';
import CircleFlag from '../../../components/CircleFlag';
import CircleStateFlag from '../../../components/CircleStateFlag';
import CircularLoader from '../../../components/CircularLoader';
import { getGameType, getCountryName, displayEnumType } from '../../../utils';
import axios from 'axios';
import apiEndPoint from '../../../utils/apiEndpoint';
import slugify from 'slugify';
import RackTracker from './RackTracker';
import { QuestionCircleFilled, CheckOutlined } from '@ant-design/icons';
import numeral from 'numeral';
import Ripples from 'react-ripples';
import dpLogoWatermarkColor from '../../../assets/img/dp-logo-watermark-color.png';
import moment from 'moment-timezone';
import momentDurationFormatSetup from 'moment-duration-format';
momentDurationFormatSetup(moment);

const { Text, Title } = Typography;
const { confirm } = Modal;

const styles = {
    container: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
    },
};

const gameTypes = {
    ONE_POCKET: 15,
    NINE_BALL: 9,
    TEN_BALL: 10,
    STRAIGHT_POOL: 15,
    EIGHT_BALL: 15,
};

export default function EventScoreboardSets(props) {
    const { client, backUrl, matchData, tournamentData, tableData, subscribeToMore, subscribeToNewData } = props;
    const [endMatchDisabled, setEndMatchDisabled] = useState(true);
    const [updateBracketMatch, updateBracketMatchRes] = useMutation(UPDATE_TOURNAMENT_BRACKET_MATCH_MUTATION);
    const [updateSet, updateSetRes] = useMutation(UPDATE_TOURNAMENT_SET_MUTATION);
    // const [scoringStarted, setScoringStarted] = useState(false);
    const [scoringStarted, setScoringStarted] = useState(matchData.is_scoring_started || false);
    const [userCheckMatchEnding, setUserCheckMatchEnding] = useState(false);
    const [thumb, setThumb] = useState();
    const [matchEnded, setMatchEnded] = useState(false);

    const sets = matchData.tournament_match_sets;
    console.log('set data', sets);

    let defaultSet = matchData.current_set ? sets && sets[matchData.current_set - 1] : sets && sets[0];
    const [currentSet, setCurrentSet] = useState(defaultSet);
    const [playerOneScore, setPlayerOneScore] = useState((currentSet && currentSet.challenger1_score) || 0);
    const [playerTwoScore, setPlayerTwoScore] = useState((currentSet && currentSet.challenger2_score) || 0);
    const formRef = useRef();

    console.log('match data', matchData);
    console.log('is scoring started', scoringStarted);

    const stats = ['Break and run', 'Table run'];
    const table = tableData;

    const challenger1 = matchData && matchData.challenger1;
    const challenger2 = matchData && matchData.challenger2;

    let challenger1RaceTo;
    let challenger2RaceTo;
    if (matchData.identifier && matchData.identifier.includes('L')) {
        challenger1RaceTo = (currentSet && currentSet.challenger1_race_to) || (matchData.tournament && matchData.tournament.losers_race_to) || 0;
        challenger2RaceTo = (currentSet && currentSet.challenger2_race_to) || (matchData.tournament && matchData.tournament.losers_race_to) || 0;
    } else {
        challenger1RaceTo = (currentSet && currentSet.challenger1_race_to) || (matchData.tournament && matchData.tournament.winners_race_to) || 0;
        challenger2RaceTo = (currentSet && currentSet.challenger2_race_to) || (matchData.tournament && matchData.tournament.winners_race_to) || 0;
    }

    let duration;
    if (matchData.start_time && matchData.end_time) {
        var start = moment(matchData.start_time);
        var end = moment(matchData.end_time);
        duration = moment.duration(end.diff(start, 'milliseconds')).format('h [hrs] m [mins]');
        // duration = moment.duration(end.diff(start, 'milliseconds')).format('hh:mm');
    } else {
        duration = moment.duration(moment.utc().diff(matchData.start_time, 'milliseconds')).format('h [hrs] m [mins]');
        // duration = moment.duration(moment.utc().diff(match.start_time, 'milliseconds')).format('hh:mm');
    }

    useEffect(() => {
        let unsubscribe;
        if (subscribeToNewData) {
            unsubscribe = subscribeToNewData(subscribeToMore);
        }
        return () => {
            if (unsubscribe) {
                unsubscribe();
            }
        };
    }, []);

    useEffect(() => {
        if (matchData) {
            console.log('match data effect', matchData);
            if (matchData.is_scoring_started !== scoringStarted) {
                setMatchEnded(false);
                setUserCheckMatchEnding(false);
                setScoringStarted(matchData.is_scoring_started || false);
                setPlayerOneScore(0);
                setPlayerTwoScore(0);
                setScoringStarted(false);
                console.log('SCORING NOT STARTED');
            } else if (matchData.status === 'PENDING') {
                setEndMatchDisabled(true);
            } else if (matchData.status !== 'PENDING' && checkForMatchWinner(matchData) === true && matchData.status !== 'COMPLETED') {
                setEndMatchDisabled(false);
                showConfirmEndMatch(matchData, tournamentData.id);
            } else {
                setEndMatchDisabled(true);
            }

            // if (matchData.tournament_match_sets) {
            //     setCurrentSet(matchData.tournament_match_sets && matchData.tournament_match_sets[0]);
            // }

            const sets = matchData.tournament_match_sets;
            let current = matchData.current_set ? sets && sets[matchData.current_set - 1] : sets && sets[0];
            setCurrentSet(current);

            if (current && (current.challenger1_score || current.challenger2_score)) {
                setPlayerOneScore(current.challenger1_score || 0);
                setPlayerTwoScore(current.challenger2_score || 0);
            }
        }
    }, [matchData]);

    async function startMatch(matchData, tournamentId) {
        console.log(matchData);

        // await resetGames(matchData);

        const startTime = moment.utc();
        const changes = {
            start_time: startTime,
            status: 'IN_PROGRESS',
            progress: 0,
            is_scoring_started: true,
        };

        const tableSlug = slugify(matchData.table_name, {
            replacement: '-',
            remove: /[*+~.,()'"#!:/@]/g,
            lower: true,
        });

        return client
            .mutate({
                mutation: UPDATE_TOURNAMENT_BRACKET_MATCH_MUTATION,
                variables: {
                    id: matchData.id,
                    tournament_id: tournamentId,
                    changes: changes,
                },
                notifyOnNetworkStatusChange: true,
                awaitRefetchQueries: true,
                // refetchQueries: [
                //     {
                //         query: GET_TOURNAMENT_BRACKET_MATCH_BY_HASH_ID,
                //         variables: { hash_id: match.hash_id, tournament_id: tournamentID },
                //     },
                // ],
            })
            .then((data) => {
                console.log(data);
                message.success(`Match started at ${moment.utc(startTime).local().format('LT')}`);

                // createFirstGame(matchData);

                console.log(tournamentData);
                console.log('LIVE STREAM SPLIT URL', tournamentData && tournamentData.livestream_split_url);

                // if (tournamentData && tournamentData.livestream_split_url) {
                //     const payload = {
                //         tournament_id: tournamentId,
                //         tournament_bracket_id: matchData.id,
                //         match_id: matchData.id,
                //         match_number: matchData.match_number,
                //         table_id: matchData.table_id,
                //         table_name: matchData.table_name,
                //         table_slug: tableSlug,
                //         game_type: tournamentData.game_type,
                //         player: matchData.challenger1_name,
                //         opponent: matchData.challenger2_name,
                //         event: 'start',
                //         webhook_url: 'https://us-central1-digital-pool.cloudfunctions.net/matchStatusUpdate',
                //         callback_url: tournamentData.livestream_split_url,
                //     };
                //     return axios
                //         .post(`${apiEndPoint}matchStatusUpdate`, payload)
                //         .then((res) => {
                //             console.log(res.data);
                //             // if (res.data && res.data.success === true) {
                //             //     message.success(JSON.stringify(res.data));
                //             // } else {
                //             //     message.warning(JSON.stringify(res.data));
                //             // }
                //             return res.data;
                //         })
                //         .catch((error) => {
                //             console.log(error);
                //             // message.error(`There was an error: ${JSON.stringify(error)}`);
                //             return error;
                //         });
                // }
            })
            .catch((error) => {
                console.error(error);
                message.error(`There was an error: ${JSON.stringify(error)}`);
                throw error;
            });
    }

    function endMatch(match, tournamentID, winner, loser) {
        const endTime = moment.utc();
        let changes;
        const challenger1_winner = winner.id === match.challenger1_id ? true : false;
        const challenger2_winner = winner.id === match.challenger2_id ? true : false;

        if (match && match.tournament && match.tournament.autopilot_mode === true) {
            changes = {
                end_time: endTime,
                status: 'COMPLETED',
                progress: 100,
                table_name: match.table_name && match.table_name,
                table_id: match.table_id && match.table_id,
                ...(challenger1_winner && { challenger1_is_winner: true, challenger2_is_winner: false }),
                ...(challenger2_winner && { challenger2_is_winner: true, challenger1_is_winner: false }),
            };

            if (match.tournament && match.tournament.livestream_split_url) {
                console.log('LIVE STREAM SPLIT URL', match.tournament && match.tournament.livestream_split_url);
                const tableSlug = slugify(table.label, {
                    replacement: '-',
                    remove: /[*+~.,()'"#!:/@]/g,
                    lower: true,
                });

                const payload = {
                    tournament_id: tournamentID,
                    match_id: match.id,
                    match_number: match.match_number,
                    table_id: match.table_id,
                    table_name: table.label,
                    table_slug: tableSlug,
                    game_type: match.tournament.game_type,
                    player: match.challenger1_name,
                    opponent: match.challenger2_name,
                    event: 'split',
                    webhook_url: 'https://us-central1-digital-pool.cloudfunctions.net/matchStatusUpdate',
                    callback_url: match.tournament.livestream_split_url,
                };

                axios
                    .post(`${apiEndPoint}matchStatusUpdate`, payload)
                    .then((res) => {
                        console.log(res.data);
                        // message.success(JSON.stringify(res.data));
                        return res.data;
                    })
                    .catch((error) => {
                        console.log(error);
                        // message.error(`There was an error: ${JSON.stringify(error)}`);
                        return error;
                    });
            }
        } else {
            changes = {
                end_time: endTime,
                status: 'PENDING',
                progress: 100,
                table_name: match.table_name && match.table_name,
                table_id: match.table_id && match.table_id,
                ...(challenger1_winner && { challenger1_is_winner: true, challenger2_is_winner: false }),
                ...(challenger2_winner && { challenger2_is_winner: true, challenger1_is_winner: false }),
            };
        }

        const tableSlug = slugify(matchData.table_name, {
            replacement: '-',
            remove: /[*+~.,()'"#!:/@]/g,
            lower: true,
        });

        return client
            .mutate({
                mutation: UPDATE_TOURNAMENT_BRACKET_MATCH_MUTATION,
                variables: {
                    id: match.id,
                    tournament_id: tournamentID,
                    changes: changes,
                },
                notifyOnNetworkStatusChange: true,
                awaitRefetchQueries: true,
                refetchQueries: [
                    {
                        query: GET_TOURNAMENT_BRACKET_MATCH_QUERY,
                        variables: { match_id: matchData.id, tournament_id: tournamentID },
                    },
                ],
            })
            .then((data) => {
                console.log(data);

                if (match && match.tournament && match.tournament.autopilot_mode === true) {
                    advanceTournamentPlayers(client, tournamentID, match, winner, loser);
                    message.success(`Match scores submitted at ${moment.utc(endTime).local().format('LT')}`);
                } else {
                    message.success(`Match scores submitted for TD approval at ${moment.utc(endTime).local().format('LT')}`);
                }

                // axios
                //     .post(
                //         'https://elicit.waypointsoftware.io/capture_post.php?xAuthentication=09e648487cf9156231d88645459d5ef0',
                //         {
                //             match_id: matchData.id,
                //         },
                //         {
                //             headers: {
                //                 'Content-Type': 'multipart/form-data',
                //             },
                //         }
                //     )
                //     .then((response) => console.log(response))
                //     .catch((error) => {
                //         console.error('There was an error!', error);
                //     });

                // if (tournamentData && tournamentData.livestream_split_url) {
                //     const payload = {
                //         tournament_id: tournamentId,
                //         match_id: matchData.id,
                //         match_number: matchData.match_number,
                //         table_id: matchData.table_id,
                //         table_name: matchData.table_name,
                //         table_slug: tableSlug,
                //         game_type: tournamentData.game_type,
                //         player: matchData.challenger1_name,
                //         opponent: matchData.challenger2_name,
                //         event: 'split',
                //         webhook_url: 'https://us-central1-digital-pool.cloudfunctions.net/matchStatusUpdate',
                //         callback_url: tournamentData.livestream_split_url,
                //     };

                //     return axios
                //         .post(`${apiEndPoint}matchStatusUpdate`, payload)
                //         .then((res) => {
                //             console.log(res.data);
                //             // message.success(JSON.stringify(res.data));
                //             return res.data;
                //         })
                //         .catch((error) => {
                //             console.log(error);
                //             // message.error(`There was an error: ${JSON.stringify(error)}`);
                //             return error;
                //         });
                // }
            })
            .catch((error) => {
                console.error(error);
                message.error(`There was an error: ${JSON.stringify(error)}`);
                throw error;
            });
    }

    function showConfirmEndMatch(matchData, tournamentId) {
        const { winner, loser } = determineMatchWinner(matchData);

        setUserCheckMatchEnding(true);

        // confirm({
        //     title: (
        //         <React.Fragment>
        //             Did {winner.name} win the match {winner.score}-{loser.score}? Please verify the scores are correct and submit for Tournament Director
        //             approval.
        //         </React.Fragment>
        //     ),
        //     centered: true,
        //     transitionName: 'fade',
        //     maskTransitionName: 'none',
        //     // onOk() {
        //     // 	return new Promise((resolve, reject) => {
        //     // 		setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
        //     // 	}).catch(() => console.log('Oops errors!'));
        //     // },
        //     onOk() {
        //         endMatch(matchData, tournamentId);
        //     },
        //     onCancel() {},
        //     okText: 'Submit Scores',
        //     cancelText: 'Cancel',
        // });
    }

    function checkForSetWinner(matchData) {
        let challenger1RaceTo;
        let challenger2RaceTo;
        console.log('match data', matchData);
        console.log('p1 score', playerOneScore);
        console.log('p2 score', playerTwoScore);
        if (matchData.identifier && matchData.identifier.includes('L')) {
            challenger1RaceTo = matchData.challenger1_race_to || (matchData.tournament && matchData.tournament.losers_race_to) || 0;
            challenger2RaceTo = matchData.challenger2_race_to || (matchData.tournament && matchData.tournament.losers_race_to) || 0;
        } else {
            challenger1RaceTo = matchData.challenger1_race_to || (matchData.tournament && matchData.tournament.winners_race_to) || 0;
            challenger2RaceTo = matchData.challenger2_race_to || (matchData.tournament && matchData.tournament.winners_race_to) || 0;
        }

        if (matchData.challenger1_score >= challenger1RaceTo || matchData.challenger2_score >= challenger2RaceTo) {
            return true;
        } else {
            return false;
        }
    }

    function determineSetWinner(matchData) {
        let challenger1RaceTo;
        let challenger2RaceTo;
        if (matchData.identifier && matchData.identifier.includes('L')) {
            challenger1RaceTo = currentSet.challenger1_race_to || (matchData.tournament && matchData.tournament.losers_race_to) || 0;
            challenger2RaceTo = currentSet.challenger2_race_to || (matchData.tournament && matchData.tournament.losers_race_to) || 0;
        } else {
            challenger1RaceTo = currentSet.challenger1_race_to || (matchData.tournament && matchData.tournament.winners_race_to) || 0;
            challenger2RaceTo = currentSet.challenger2_race_to || (matchData.tournament && matchData.tournament.winners_race_to) || 0;
        }
        let winner;
        let loser;

        console.log({
            playerOneScore,
            challenger1RaceTo,
            playerTwoScore,
            challenger2RaceTo,
        });

        if (matchData.challenger1_score >= challenger1RaceTo) {
            winner = {
                id: matchData.challenger1_id,
                name: matchData.challenger1_name,
                country: matchData.challenger1_country,
                score: matchData.challenger1_score,
                is_winner: true,
            };
            loser = {
                id: matchData.challenger2_id,
                name: matchData.challenger2_name,
                country: matchData.challenger2_country,
                score: matchData.challenger2_score,
                is_winner: false,
            };
        } else if (matchData.challenger2_score >= challenger2RaceTo) {
            winner = {
                id: matchData.challenger2_id,
                name: matchData.challenger2_name,
                country: matchData.challenger2_country,
                score: matchData.challenger2_score,
                is_winner: true,
            };
            loser = {
                id: matchData.challenger1_id,
                name: matchData.challenger1_name,
                country: matchData.challenger1_country,
                score: matchData.challenger1_score,
                is_winner: false,
            };
        }

        console.log({
            winner,
            loser,
        });

        return {
            winner,
            loser,
        };
    }

    function checkForMatchWinner(matchData) {
        const challenger1SetsWon = totalSetsWon('challenger1', matchData.tournament_match_sets) || 0;
        const challenger2SetsWon = totalSetsWon('challenger2', matchData.tournament_match_sets) || 0;
        const bestOfSets = Math.round(tournamentData.sets_per_match / 2);

        console.log({
            challenger1SetsWon,
            challenger2SetsWon,
            bestOfSets,
        });
        console.log('match data', matchData);
        console.log('p1 score', playerOneScore);
        console.log('p2 score', playerTwoScore);
        if (matchData.identifier && matchData.identifier.includes('L')) {
            challenger1RaceTo = (currentSet && currentSet.challenger1_race_to) || (matchData.tournament && matchData.tournament.losers_race_to) || 0;
            challenger2RaceTo = (currentSet && currentSet.challenger2_race_to) || (matchData.tournament && matchData.tournament.losers_race_to) || 0;
        } else {
            challenger1RaceTo = (currentSet && currentSet.challenger1_race_to) || (matchData.tournament && matchData.tournament.winners_race_to) || 0;
            challenger2RaceTo = (currentSet && currentSet.challenger2_race_to) || (matchData.tournament && matchData.tournament.winners_race_to) || 0;
        }

        if (challenger1SetsWon >= bestOfSets || challenger2SetsWon >= bestOfSets) {
            return true;
        } else {
            return false;
        }
    }

    function determineMatchWinner(matchData) {
        const challenger1SetsWon = totalSetsWon('challenger1', matchData.tournament_match_sets) || 0;
        const challenger2SetsWon = totalSetsWon('challenger2', matchData.tournament_match_sets) || 0;
        const bestOfSets = Math.round(tournamentData.sets_per_match / 2);
        if (matchData.identifier && matchData.identifier.includes('L')) {
            challenger1RaceTo = (currentSet && currentSet.challenger1_race_to) || (matchData.tournament && matchData.tournament.losers_race_to) || 0;
            challenger2RaceTo = (currentSet && currentSet.challenger2_race_to) || (matchData.tournament && matchData.tournament.losers_race_to) || 0;
        } else {
            challenger1RaceTo = (currentSet && currentSet.challenger1_race_to) || (matchData.tournament && matchData.tournament.winners_race_to) || 0;
            challenger2RaceTo = (currentSet && currentSet.challenger2_race_to) || (matchData.tournament && matchData.tournament.winners_race_to) || 0;
        }
        let winner;
        let loser;

        if (challenger1SetsWon >= bestOfSets) {
            winner = {
                id: matchData.challenger1_id,
                name: matchData.challenger1_name,
                country: matchData.challenger1_country,
                score: playerOneScore,
                is_winner: true,
            };
            loser = {
                id: matchData.challenger2_id,
                name: matchData.challenger2_name,
                country: matchData.challenger2_country,
                score: playerTwoScore,
                is_winner: false,
            };
        } else if (challenger2SetsWon >= bestOfSets) {
            winner = {
                id: matchData.challenger2_id,
                name: matchData.challenger2_name,
                country: matchData.challenger2_country,
                score: playerTwoScore,
                is_winner: true,
            };
            loser = {
                id: matchData.challenger1_id,
                name: matchData.challenger1_name,
                country: matchData.challenger1_country,
                score: playerOneScore,
                is_winner: false,
            };
        }

        console.log({
            winner,
            loser,
        });

        return {
            winner,
            loser,
        };
    }

    function updateStats(currentGame, stats) {
        if (currentGame.id) {
            const changes = {
                player_break_run: stats ? stats.playerBreakRun : false,
                player_runout: stats ? stats.playerRunout : false,
                opponent_break_run: stats ? stats.opponentBreakRun : false,
                opponent_runout: stats ? stats.opponentRunout : false,
            };

            // updateGame(currentGame.id, changes);
        }
    }

    function getMatchProgress(matchData) {
        const totalRace = parseInt(challenger1RaceTo + challenger2RaceTo);
        const matchProgress =
            matchData.status === 'COMPLETED'
                ? 100
                : parseInt(playerOneScore) >= totalRace || parseInt(playerTwoScore) >= totalRace
                ? 100
                : (((playerOneScore + playerTwoScore) / totalRace) * 100).toFixed(0);
        return parseInt(matchProgress);
    }

    function incrementPlayerScore(challenger, score, matchData, gameData, stats) {
        const matchProgress = getMatchProgress(matchData);
        const newScore = score + 1;
        const totalScore = newScore;
        if (challenger === 'challenger1') {
            setPlayerOneScore(newScore);
        } else {
            setPlayerTwoScore(newScore);
        }
        const changes = {
            ...(challenger === 'challenger1' ? { challenger1_score: newScore } : { challenger2_score: newScore }),
            progress: matchProgress,
        };
        console.log('total score', totalScore);
        updateMatch(changes, matchData)
            .then((result) => {
                console.log(result);
                // addGame(challenger, newScore, matchData, tournamentData, gameData, stats);
            })
            .catch((error) => {
                console.log(error);
                message.error('There was an error', error);
            });
    }

    function decrementPlayerScore(challenger, score, matchData, gameData) {
        const matchProgress = getMatchProgress(matchData);
        const newScore = score - 1;
        const totalScore = playerOneScore + playerTwoScore - 1;
        if (challenger === 'challenger1') {
            setPlayerOneScore(newScore);
        } else {
            setPlayerTwoScore(newScore);
        }
        const changes = {
            ...(challenger === 'challenger1' ? { challenger1_score: newScore } : { challenger2_score: newScore }),
            ...(totalScore === 0 && { is_scoring_started: false }),
            progress: matchProgress,
        };

        console.log('total score', totalScore);
        updateMatch(changes, matchData)
            .then((result) => {
                console.log(result);
                // if (totalScore > 0) {
                //     removeGame(challenger, matchData, tournamentData, gameData);
                // } else {
                //     console.log('reset games');
                //     resetGames(matchData);
                // }
            })
            .catch((error) => {
                console.log(error);
                message.error('There was an error', error);
            });
    }

    function setPlayerTurn(player) {
        let currentPlayer;
        if (player === 'challenger1') {
            currentPlayer = matchData.challenger1_name;
        } else {
            currentPlayer = matchData.challenger2_name;
        }

        return updateBracketMatch({
            variables: {
                id: matchData.id,
                tournament_id: tournamentData.id,
                changes: {
                    ...(player === 'challenger1'
                        ? { challenger1_is_playing: true, challenger2_is_playing: false }
                        : { challenger2_is_playing: true, challenger1_is_playing: false }),
                },
            },
            notifyOnNetworkStatusChange: true,
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: GET_TOURNAMENT_BRACKET_MATCH_QUERY,
                    variables: { match_id: matchData.id, tournament_id: tournamentData.id },
                },
            ],
        })
            .then((data) => {
                const key = 'playerTurn';

                console.log(data);
                message.success({
                    content: `${currentPlayer} is at the table`,
                    key,
                    duration: 1,
                });
                return data;
            })
            .catch((error) => {
                console.error(error);
                message.info('There was an error', error);
                return error;
            });
    }

    function updateMatch(changes, matchData) {
        console.log(changes);
        console.log(matchData);

        const mergedData = {
            ...matchData,
            ...changes,
        };

        if (matchData.eventSlug) {
            // const challenger1SetsWon = totalSetsWon('challenger1', matchData.tournament_match_sets) || 0;
            // const challenger2SetsWon =  totalSetsWon('challenger2', matchData.tournament_match_sets) || 0;
            // const bestOfSets = Math.round(tournamentData.sets_per_match / 2);
            const isWinner = checkForSetWinner(mergedData);
            const { winner, loser } = determineSetWinner(mergedData);

            console.log({
                currentSet: currentSet.number,
                isWinner,
                winner,
                loser,
            });

            return updateBracketMatch({
                variables: {
                    id: matchData.id,
                    tournament_id: tournamentData.id,
                    changes: {
                        current_set: currentSet.number,
                    },
                },
                awaitRefetchQueries: true,
                refetchQueries: [
                    {
                        query: GET_TOURNAMENT_BRACKET_MATCH_QUERY,
                        variables: { match_id: matchData.id, tournament_id: tournamentData.id },
                    },
                ],
            })
                .then((data) => {
                    console.log(data);
                    // handleMatchUpdate(matchData);

                    updateSet({
                        variables: {
                            id: currentSet.id,
                            tournament_id: tournamentData.id,
                            changes: {
                                ...changes,
                                ...(isWinner === true
                                    ? {
                                          challenger1_is_winner: winner.id === matchData.challenger1_id ? true : false,
                                          challenger2_is_winner: winner.id === matchData.challenger2_id ? true : false,
                                      }
                                    : { challenger1_is_winner: false, challenger2_is_winner: false }),
                                number: currentSet.number,
                                status: isWinner === true ? 'COMPLETED' : null,
                            },
                        },
                        // awaitRefetchQueries: true,
                        // refetchQueries: [
                        //     {
                        //         query: GET_TOURNAMENT_MATCH_SETS_QUERY,
                        //         variables: { tournament_bracket_id: matchData.id, tournament_id: tournamentData.id },
                        //     },
                        // ],
                        optimisticResponse: {
                            updateSet: {
                                id: currentSet.id,
                                ...changes,
                                __typename: 'tournament_match_sets_mutation_response',
                            },
                        },
                        update: (cache, { data }) => {
                            console.log({
                                cache,
                                data,
                                matchData,
                            });

                            if (matchData.eventSlug) {
                                // Get the current cached data.
                                const existingMatchData = client.readQuery({
                                    // The cached query key is the same as the name of the GQL schema
                                    query: GET_EVENT_LIVE_TABLE_QUERY,
                                    variables: { event_slug: matchData.eventSlug, table_slug: matchData.tableSlug },
                                });

                                console.log(existingMatchData);
                                console.log(data);

                                // Now we combine the optimisticResponse we passed in earlier and the existing data
                                let newMatches;
                                if (existingMatchData && existingMatchData.tournaments) {
                                    newMatches = data.updateSet && data.updateSet.length > 0 && [data.updateSet, existingMatchData.tournaments];
                                } else {
                                    newMatches = data.updateSet && data.updateSet.length > 0 && [data.updateSet];
                                }

                                console.log('new matches', newMatches);
                                // Finally we overwrite the cache
                                if (newMatches && newMatches.length > 0) {
                                    cache.writeQuery({
                                        query: GET_EVENT_LIVE_TABLE_QUERY,
                                        variables: { event_slug: matchData.eventSlug, table_slug: matchData.tableSlug },
                                        data: newMatches,
                                    });
                                }
                            }
                        },
                    })
                        .then((data) => {
                            console.log(data);
                            // handleMatchUpdate(matchData);
                            // checkForWinner(matchData);
                            return data;
                            // message.success({
                            // 	content: `${text} updated`,
                            // 	key,
                            // 	duration: 1
                            // });
                        })
                        .catch((error) => {
                            console.error(error);
                            message.info('There was an error', error);
                            return error;
                        });

                    return data;
                    // message.success({
                    // 	content: `${text} updated`,
                    // 	key,
                    // 	duration: 1
                    // });
                })
                .catch((error) => {
                    console.error(error);
                    message.info('There was an error', error);
                    return error;
                });
        }
    }

    function startScoring() {
        setScoringStarted(true);
    }

    function isDisabled(matchData) {
        return matchData.status === 'PENDING' || matchData.status === 'COMPLETED';
    }

    function totalSetsWon(player, sets) {
        if (player === 'challenger1') {
            return sets
                .map((set) => {
                    return set.challenger1_score === set.challenger1_race_to;
                })
                .reduce((acc, total) => {
                    return acc + total;
                }, 0);
        } else if (player === 'challenger2') {
            return sets
                .map((set) => {
                    return set.challenger2_score === set.challenger2_race_to;
                })
                .reduce((acc, total) => {
                    return acc + total;
                }, 0);
        }
    }

    function formatPlayerName(matchData, challenger) {
        if (challenger === 'challenger1') {
            return ((matchData && matchData.challenger1_name && matchData.challenger1_skill_level) || (challenger1 && challenger1.skill_level)) &&
                matchData.challenger1_race_to &&
                tournamentData.show_player_skill_levels === true &&
                tournamentData.show_player_races === true
                ? matchData &&
                      `${matchData.challenger1_name} ${matchData.challenger1_skill_level || (challenger1 && challenger1.skill_level)} (${
                          matchData.challenger1_race_to
                      })`
                : matchData && matchData.challenger1_name && matchData.challenger1_race_to && tournamentData.show_player_races === true
                ? matchData && `${matchData.challenger1_name} (${matchData.challenger1_race_to})`
                : matchData && `${matchData.challenger1_name}`;
        } else if (challenger === 'challenger2') {
            return ((matchData && matchData.challenger2_name && matchData.challenger2_skill_level) || (challenger1 && challenger2.skill_level)) &&
                matchData.challenger2_race_to &&
                tournamentData.show_player_skill_levels === true &&
                tournamentData.show_player_races === true
                ? matchData &&
                      `${matchData.challenger2_name} ${matchData.challenger2_skill_level || (challenger1 && challenger2.skill_level)} (${
                          matchData.challenger2_race_to
                      })`
                : matchData && matchData.challenger2_name && matchData.challenger2_race_to && tournamentData.show_player_races === true
                ? matchData && `${matchData.challenger2_name} (${matchData.challenger2_race_to})`
                : matchData && `${matchData.challenger2_name}`;
        }
    }

    return (
        <Query
            query={GET_TOURNAMENT_MATCH_GAMES_QUERY}
            fetchPolicy="cache-and-network"
            notifyOnNetworkStatusChange={true}
            variables={{ tournament_id: tournamentData.id, tournament_bracket_id: matchData.id }}
            onCompleted={(data, error, loading) => {
                console.log('match games', data);
            }}
        >
            {({ loading, error, data, refetch }) => {
                if (loading) return <CircularLoader />;
                if (error) return <div>Error: {error.message}</div>;

                const gameData = data && data.tournament_match_games;
                const currentGame = gameData && gameData[gameData.length - 1];
                console.log('current game', currentGame);
                console.log('match data', matchData);

                const initialValues = {};
                stats.forEach((stat, index) => {
                    const statUnderscored = stat.split(' ').join('_').toLowerCase();
                    const keyPlayer = `player_${statUnderscored}`;
                    const keyOpponent = `opponent_${statUnderscored}`;
                    initialValues[keyPlayer] = (currentGame && currentGame[keyPlayer]) || 0;
                    initialValues[keyOpponent] = (currentGame && currentGame[keyOpponent]) || 0;
                });

                return (
                    <React.Fragment>
                        {thumb && (
                            <div style={{ position: 'absolute', top: 0, left: 0, zIndex: 10, width: 800 }}>
                                <img src={`data:image/png;base64, ${thumb}`} alt="Table Thumbnail" width="100%" />
                            </div>
                        )}

                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                paddingTop: 10,
                                paddingBottom: 10,
                                paddingLeft: 10,
                                paddingRight: 20,
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                zIndex: 11,
                                // boxShadow: 'rgb(0 0 0 / 20%) 0px 1px 15px 0px'
                            }}
                        >
                            <div />

                            <div>
                                {matchEnded === true && (
                                    <div>
                                        <div
                                            style={{
                                                position: 'fixed',
                                                width: '100%',
                                                height: '100%',
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <Title
                                                level={1}
                                                style={{
                                                    paddingTop: 20,
                                                    paddingBottom: 20,
                                                    paddingLeft: 25,
                                                    paddingRight: 25,
                                                    margin: 0,
                                                    color: '#fff',
                                                    background: 'rgba(255,255,255,0.05)',
                                                    borderRadius: 20,
                                                    textTransform: 'uppercase',
                                                    letterSpacing: 2,
                                                    fontSize: 60,
                                                }}
                                            >
                                                Match finished
                                            </Title>
                                        </div>
                                    </div>
                                )}
                                {userCheckMatchEnding === true && matchEnded === false && (
                                    <div>
                                        <div
                                            style={{
                                                position: 'fixed',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Ripples color="#000">
                                                <Button
                                                    size="large"
                                                    type="primary"
                                                    onClick={() => {
                                                        setMatchEnded(true);
                                                        const { winner, loser } = determineMatchWinner(matchData);
                                                        endMatch(matchData, tournamentData.id, winner, loser);
                                                    }}
                                                    style={{
                                                        width: '100%',
                                                        paddingLeft: 40,
                                                        paddingRight: 40,
                                                        height: 160,
                                                        fontSize: 100,
                                                        fontWeight: 700,
                                                        borderRadius: 20,
                                                        // textShadow: '0 2px 5px rgba(0,0,0,0.25)',
                                                    }}
                                                >
                                                    SUBMIT FINAL SCORES
                                                </Button>
                                            </Ripples>
                                            <Ripples color="#000">
                                                <Button
                                                    size="large"
                                                    type="ghost"
                                                    onClick={() => {
                                                        setUserCheckMatchEnding(false);
                                                    }}
                                                    style={{
                                                        marginTop: 20,
                                                        paddingLeft: 40,
                                                        paddingRight: 40,
                                                        height: 140,
                                                        fontSize: 80,
                                                        fontWeight: 700,
                                                        borderRadius: 20,
                                                        color: '#fff',
                                                        // textShadow: '0 2px 5px rgba(0,0,0,0.25)',
                                                    }}
                                                >
                                                    GO BACK
                                                </Button>
                                            </Ripples>
                                        </div>
                                    </div>
                                )}
                                {matchData.status === 'IN_PROGRESS' && (playerOneScore > 0 || playerTwoScore > 0) && userCheckMatchEnding === false ? (
                                    <Tooltip
                                        placement="left"
                                        title={
                                            endMatchDisabled === true
                                                ? matchData.status === 'PENDING'
                                                    ? 'Match scores have already been submitted and are awaiting approval.'
                                                    : 'Cannot submit final scores until a winner has been determined'
                                                : 'Submit final scores for approval'
                                        }
                                    >
                                        <Button
                                            size="large"
                                            type="ghost"
                                            ghost
                                            onClick={() => {
                                                showConfirmEndMatch(matchData, tournamentData.id);
                                            }}
                                            disabled={endMatchDisabled || false}
                                            className={endMatchDisabled === true ? 'disabled' : ''}
                                        >
                                            Submit Final Scores
                                        </Button>
                                    </Tooltip>
                                ) : (
                                    matchData.status === 'PENDING' && <Text style={{ color: '#fff' }}>Scores pending TD approval</Text>
                                )}
                            </div>
                        </div>

                        {userCheckMatchEnding === true && (
                            <div
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    zIndex: 10,
                                    background: 'rgba(0,0,0,0.6)',
                                }}
                            />
                        )}

                        <div
                            style={{
                                flex: 1,
                                alignItems: 'center',
                                // padding: 20,
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'column',
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', marginBottom: 0, minHeight: 20 }}>
                                {tournamentData.logo && <img src={tournamentData.logo} alt="Logo" height={120} />}
                            </div>

                            <Formik
                                ref={formRef}
                                onSubmit={(data, actions) => {
                                    console.log(data);
                                }}
                                // validationSchema={schema}
                                enableReinitialize
                                initialValues={initialValues}
                                render={({ errors, touched, values }) => (
                                    <Form
                                        layout="vertical"
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            console.log(values);
                                            // handleSubmit(values);
                                        }}
                                        style={{ display: 'flex', alignItems: 'center', width: '100%', flexDirection: 'column' }}
                                    >
                                        <Row gutter={16} type="flex" justify="space-between" style={{ width: '100%', position: 'relative' }}>
                                            <Col xs={12} sm={12}>
                                                <Title level={2} style={{ marginLeft: 20, marginTop: 0, marginBottom: 0, color: '#fff' }}>
                                                    {table.label} - Match {matchData.match_number} ({matchData.identifier})
                                                </Title>
                                            </Col>
                                            <div style={{ top: 8, position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
                                                <Title level={2} style={{ marginLeft: 20, marginTop: 0, marginBottom: 0, color: '#fff', fontWeight: 400 }}>
                                                    {tournamentData.name}
                                                </Title>
                                            </div>
                                            <Col xs={12} sm={12} align="right">
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                                    <Avatar
                                                        size={28}
                                                        src={getGameType(tournamentData.game_type, 'dark')}
                                                        style={{ width: 30, marginRight: 10 }}
                                                    />
                                                    <Title level={2} style={{ marginRight: 20, marginTop: 0, marginBottom: 0, color: '#fff' }}>
                                                        Race to {challenger1RaceTo}/{challenger2RaceTo}
                                                    </Title>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row gutter={24} type="flex" justify="space-between" style={{ width: '100%' }}>
                                            <Col xs={12} sm={12}>
                                                <div
                                                    style={{
                                                        display: 'inline-flex',
                                                        flex: 1,
                                                        background:
                                                            playerOneScore > playerTwoScore
                                                                ? 'linear-gradient(45deg, #0089cd, #0045b5)'
                                                                : 'linear-gradient(-45deg, black, transparent)',
                                                        // background: 'linear-gradient(206deg, #0045B4 0%, #0284CB 95%)',
                                                        borderRadius: 30,
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        flexDirection: 'column',
                                                        padding: 20,
                                                        filter: 'drop-shadow(0px 20px 10px rgba(0,0,0,0.2))',
                                                        cursor: 'pointer',
                                                        width: '100%',
                                                        height: '100%',
                                                        position: 'relative',
                                                    }}
                                                    onClick={() => {
                                                        setPlayerTurn('challenger1');
                                                    }}
                                                    className="ripple"
                                                >
                                                    <div style={{ marginTop: 40, marginBottom: 10, paddingLeft: 20 }}>
                                                        {matchData.challenger1_country && (
                                                            <React.Fragment>
                                                                {matchData.challenger1_state ? (
                                                                    <CircleStateFlag
                                                                        state={matchData.challenger1_state}
                                                                        size="large"
                                                                        style={{ transform: 'scale(1.8)' }}
                                                                    />
                                                                ) : (
                                                                    <CircleFlag
                                                                        country={getCountryName(matchData.challenger1_country) || 'Unknown'}
                                                                        size="large"
                                                                        style={{ transform: 'scale(1.8)' }}
                                                                    />
                                                                )}
                                                            </React.Fragment>
                                                        )}
                                                    </div>
                                                    <div style={{ marginTop: 10, textAlign: 'center' }}>
                                                        <Text style={{ fontSize: 40, fontWeight: 700, color: '#fff', textTransform: 'uppercase' }}>
                                                            {formatPlayerName(matchData, 'challenger1')}
                                                        </Text>
                                                    </div>
                                                    <div>
                                                        <Text style={{ margin: 0, fontSize: 200, lineHeight: '210px', fontWeight: 700, color: '#fff' }}>
                                                            {playerOneScore || 0}
                                                        </Text>
                                                    </div>
                                                    {matchData.challenger1_is_playing === true && <div className="arrow-right"></div>}

                                                    {/* <div
                                                        style={{
                                                            backgroundColor: 'rgba(255,255,255, 0.05)',
                                                            paddingLeft: 10,
                                                            paddingRight: 10,
                                                            paddingTop: 5,
                                                            paddingBottom: 5,
                                                            borderRadius: 10,
                                                            fontSize: 20,
                                                        }}
                                                    >
                                                        <Text style={{ color: '#fff', fontWeight: 700, fontSize: 25 }}>
                                                            TPA: {(currentGame && currentGame.player_tpa) || '0.000'}
                                                        </Text>
                                                    </div> */}
                                                </div>
                                            </Col>

                                            <Col xs={12} sm={12}>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flex: 1,
                                                        background:
                                                            playerTwoScore > playerOneScore
                                                                ? 'linear-gradient(45deg, #0089cd, #0045b5)'
                                                                : 'linear-gradient(45deg, black, transparent)',
                                                        // background: 'linear-gradient(180deg, #0F141A 0%, #495C75 100%)',
                                                        borderRadius: 30,
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        flexDirection: 'column',
                                                        padding: 20,
                                                        filter: 'drop-shadow(0px 20px 10px rgba(0,0,0,0.2))',
                                                        cursor: 'pointer',
                                                        height: '100%',
                                                    }}
                                                    onClick={() => {
                                                        setPlayerTurn('challenger2');
                                                    }}
                                                    className="ripple"
                                                >
                                                    <div style={{ marginTop: 40, marginBottom: 10, paddingLeft: 20 }}>
                                                        {matchData.challenger2_country && (
                                                            <React.Fragment>
                                                                {matchData.challenger2_state ? (
                                                                    <CircleStateFlag state={playerTwoScore} size="large" style={{ transform: 'scale(1.8)' }} />
                                                                ) : (
                                                                    <CircleFlag
                                                                        country={getCountryName(matchData.challenger2_country) || 'Unknown'}
                                                                        size="large"
                                                                        style={{ transform: 'scale(1.8)' }}
                                                                    />
                                                                )}
                                                            </React.Fragment>
                                                        )}
                                                    </div>
                                                    <div style={{ marginTop: 10, textAlign: 'center' }}>
                                                        <Text style={{ fontSize: 40, fontWeight: 700, color: '#fff', textTransform: 'uppercase' }}>
                                                            {formatPlayerName(matchData, 'challenger2')}
                                                        </Text>
                                                    </div>
                                                    <div>
                                                        <Text style={{ margin: 0, fontSize: 200, lineHeight: '210px', fontWeight: 700, color: '#fff' }}>
                                                            {playerTwoScore || 0}
                                                        </Text>
                                                    </div>
                                                    {matchData.challenger2_is_playing === true && <div className="arrow-left"></div>}

                                                    {/* <div
                                                        style={{
                                                            backgroundColor: 'rgba(255,255,255, 0.05)',
                                                            paddingLeft: 10,
                                                            paddingRight: 10,
                                                            paddingTop: 5,
                                                            paddingBottom: 5,
                                                            borderRadius: 10,
                                                            fontSize: 20,
                                                        }}
                                                    >
                                                        <Text style={{ color: '#fff', fontWeight: 700, fontSize: 25 }}>
                                                            TPA: {(currentGame && currentGame.opponent_tpa) || '0.000'}
                                                        </Text>
                                                    </div> */}
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row gutter={16} type="flex" justify="space-between" style={{ position: 'relative', zIndex: 1, width: '100%' }}>
                                            <Col xs={12} sm={12}>
                                                <div style={{ margin: 20, display: 'flex', justifyContent: 'center' }}>
                                                    <Ripples color="#ccc">
                                                        <Button
                                                            type="primary"
                                                            ghost
                                                            shape="circle"
                                                            size="large"
                                                            style={{ width: 100, height: 100, borderWidth: 5 }}
                                                            disabled={isDisabled(matchData) === true || playerOneScore === challenger1RaceTo ? true : false}
                                                            onClick={() => {
                                                                console.log('increment player score', matchData);
                                                                if (playerOneScore >= 0 && playerOneScore <= challenger1RaceTo) {
                                                                    // showConfirmStats('challenger1', matchData.challenger1_score, matchData, gameData);
                                                                    incrementPlayerScore('challenger1', playerOneScore, matchData, gameData);
                                                                }
                                                            }}
                                                            className={isDisabled(matchData) === true || playerOneScore === challenger1RaceTo ? 'disabled' : ''}
                                                        >
                                                            <Icon type="plus" style={{ fontSize: 50, lineHeight: '40px' }} />
                                                        </Button>
                                                    </Ripples>
                                                    <div style={{ width: 20 }} />
                                                    <Ripples color="#ccc">
                                                        <Button
                                                            type="danger"
                                                            ghost
                                                            shape="circle"
                                                            size="large"
                                                            style={{ width: 100, height: 100, borderWidth: 5 }}
                                                            disabled={isDisabled(matchData) === true || playerOneScore === 0 ? true : false}
                                                            onClick={() => {
                                                                console.log('decrement player score', matchData);
                                                                if (playerOneScore > 0) {
                                                                    decrementPlayerScore('challenger1', playerOneScore, matchData, gameData);
                                                                }
                                                            }}
                                                            className={isDisabled(matchData) === true || playerOneScore === 0 ? 'disabled' : ''}
                                                        >
                                                            <Icon type="minus" style={{ fontSize: 50, lineHeight: '40px' }} />
                                                        </Button>
                                                    </Ripples>
                                                </div>
                                            </Col>
                                            <Col xs={12} sm={12}>
                                                <div style={{ margin: 20, display: 'flex', justifyContent: 'center' }}>
                                                    <Ripples color="#ccc">
                                                        <Button
                                                            type="primary"
                                                            ghost
                                                            shape="circle"
                                                            size="large"
                                                            style={{ width: 100, height: 100, borderWidth: 5 }}
                                                            disabled={isDisabled(matchData) === true || playerTwoScore === challenger2RaceTo ? true : false}
                                                            onClick={() => {
                                                                console.log('increment player score', matchData);
                                                                if (playerTwoScore >= 0 && playerTwoScore <= challenger2RaceTo) {
                                                                    // showConfirmStats('challenger2', matchData.challenger2_score, matchData, gameData);
                                                                    incrementPlayerScore('challenger2', playerTwoScore, matchData, gameData);
                                                                }
                                                            }}
                                                            className={isDisabled(matchData) === true || playerTwoScore === challenger2RaceTo ? 'disabled' : ''}
                                                        >
                                                            <Icon type="plus" style={{ fontSize: 50, lineHeight: '40px' }} />
                                                        </Button>
                                                    </Ripples>
                                                    <div style={{ width: 20 }} />
                                                    <Ripples color="#ccc">
                                                        <Button
                                                            type="danger"
                                                            ghost
                                                            shape="circle"
                                                            size="large"
                                                            style={{ width: 100, height: 100, borderWidth: 5 }}
                                                            disabled={isDisabled(matchData) === true || playerTwoScore === 0 ? true : false}
                                                            onClick={() => {
                                                                console.log('decrement player score', matchData);
                                                                if (playerTwoScore > 0) {
                                                                    decrementPlayerScore('challenger2', playerTwoScore, matchData, gameData);
                                                                }
                                                            }}
                                                            className={isDisabled(matchData) === true || playerTwoScore === 0 ? 'disabled' : ''}
                                                        >
                                                            <Icon type="minus" style={{ fontSize: 50, lineHeight: '40px' }} />
                                                        </Button>
                                                    </Ripples>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row gutter={16} type="flex" justify="space-between" style={{ marginTop: -120 }}>
                                            <Col xs={24} align="center">
                                                <div style={{ marginBottom: 10 }}>
                                                    <Tag
                                                        size="large"
                                                        color={
                                                            matchData.status === 'NOT_STARTED'
                                                                ? '#80848c'
                                                                : matchData.status === 'IN_PROGRESS'
                                                                ? '#108ee9'
                                                                : matchData.status === 'PENDING'
                                                                ? '#009ba2'
                                                                : '#cd201f'
                                                        }
                                                    >
                                                        {matchData.status}
                                                    </Tag>
                                                </div>
                                                <div>
                                                    <Text style={{ fontSize: 40, color: '#fff', fontWeight: 700 }}>
                                                        <span>Set {(currentSet && currentSet.number) || 1} </span>
                                                        <span> - </span>
                                                        <span>
                                                            Rack{' '}
                                                            {playerOneScore + playerTwoScore === 0
                                                                ? 1
                                                                : playerOneScore + playerTwoScore === challenger1RaceTo + challenger2RaceTo
                                                                ? playerOneScore + playerTwoScore
                                                                : playerOneScore + playerTwoScore + 1}
                                                        </span>
                                                    </Text>
                                                </div>
                                                <div>
                                                    <Text style={{ fontSize: 30, color: '#fff' }}>{duration || '0 minutes'}</Text>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row gutter={16} type="flex" justify="center" style={{ width: '100%', paddingBottom: 10, paddingTop: 10 }}>
                                            <Col xs={24} align="center">
                                                {sets &&
                                                    sets.map((set, index) => (
                                                        <Ripples color="#ccc" key={index}>
                                                            <Button
                                                                type={currentSet && currentSet.number === index + 1 ? 'primary' : 'ghost'}
                                                                size="large"
                                                                ghost
                                                                onClick={() => {
                                                                    const selectedSet = sets && sets[index];

                                                                    setPlayerOneScore(selectedSet.challenger1_score || 0);
                                                                    setPlayerTwoScore(selectedSet.challenger2_score || 0);
                                                                    setCurrentSet(selectedSet);

                                                                    return updateBracketMatch({
                                                                        variables: {
                                                                            id: matchData.id,
                                                                            tournament_id: tournamentData.id,
                                                                            changes: {
                                                                                current_set: selectedSet.number,
                                                                            },
                                                                        },
                                                                        awaitRefetchQueries: true,
                                                                        refetchQueries: [
                                                                            {
                                                                                query: GET_TOURNAMENT_BRACKET_MATCH_QUERY,
                                                                                variables: { match_id: matchData.id, tournament_id: tournamentData.id },
                                                                            },
                                                                        ],
                                                                    })
                                                                        .then((data) => {
                                                                            console.log(data);
                                                                            return data;
                                                                        })
                                                                        .catch((error) => {
                                                                            console.error(error);
                                                                            message.info('There was an error', error);
                                                                            return error;
                                                                        });
                                                                }}
                                                                // disabled={currentGame && currentGame.player_is_winner === true ? false : true}
                                                                style={{
                                                                    height: 60,
                                                                    width: 60,
                                                                    marginLeft: 5,
                                                                    marginRight: 5,
                                                                    fontSize: 30,
                                                                    fontWeight: 700,
                                                                    borderRadius: 50,
                                                                    // textShadow: '0 2px 5px rgba(0,0,0,0.25)',
                                                                }}
                                                            >
                                                                {currentGame && currentGame.player_break_run === true && <CheckOutlined />} {index + 1}
                                                            </Button>
                                                        </Ripples>
                                                    ))}
                                            </Col>
                                        </Row>
                                        <Row gutter={8} type="flex" justify="center">
                                            <Col xs={24} align="center" style={{ padding: 0 }}>
                                                <div
                                                    style={{
                                                        marginTop: 10,
                                                        border: '1px solid rgba(255,255,255,0.3)',
                                                        borderRadius: 10,
                                                        paddingTop: 5,
                                                        paddingBottom: 5,
                                                        paddingLeft: 15,
                                                        paddingRight: 15,
                                                    }}
                                                >
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                                        <div style={{ textAlign: 'right', display: 'flex', flex: 1, alignItems: 'center', paddingLeft: 5 }}>
                                                            {matchData && matchData.challenger1_country && (
                                                                <CircleFlag
                                                                    country={getCountryName(matchData.challenger1_country) || 'Unknown'}
                                                                    size="medium"
                                                                />
                                                            )}
                                                            <Text
                                                                style={{
                                                                    fontSize: 20,
                                                                    textAlign: 'left',
                                                                    whiteSpace: 'nowrap',
                                                                    fontWeight: 'bold',
                                                                    textTransform: 'uppercase',
                                                                    marginRight: 10,
                                                                }}
                                                            >
                                                                {matchData.challenger1_name}
                                                            </Text>
                                                        </div>
                                                        {sets &&
                                                            sets.map((set, index) => {
                                                                return (
                                                                    <div key={index} style={{ padding: 5, width: 30, textAlign: 'center' }}>
                                                                        <Text
                                                                            style={{
                                                                                fontSize: 18,
                                                                                color: set.challenger1_score === set.challenger1_race_to && '#86d068',
                                                                                fontWeight:
                                                                                    set.challenger1_score === set.challenger1_race_to ||
                                                                                    set.challenger1_score > set.challenger2_score
                                                                                        ? 'bold'
                                                                                        : 'normal',
                                                                            }}
                                                                        >
                                                                            {set.challenger1_score}
                                                                        </Text>
                                                                    </div>
                                                                );
                                                            })}
                                                        <div
                                                            style={{
                                                                width: 30,
                                                                paddingTop: 5,
                                                                paddingBottom: 5,
                                                                paddingLeft: 10,
                                                                paddingRight: 10,
                                                                backgroundColor: 'rgba(0,0,0,0.8)',
                                                                borderRadius: 10,
                                                            }}
                                                        >
                                                            <Text
                                                                style={{
                                                                    fontSize: 18,
                                                                    color:
                                                                        totalSetsWon('challenger1', matchData.tournament_match_sets) >
                                                                            totalSetsWon('challenger2', matchData.tournament_match_sets) && '#86d068',
                                                                    fontWeight: 'bold',
                                                                }}
                                                            >
                                                                {totalSetsWon('challenger1', matchData.tournament_match_sets) || 0}
                                                            </Text>
                                                        </div>
                                                    </div>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                                        <div style={{ textAlign: 'right', display: 'flex', flex: 1, alignItems: 'center', paddingLeft: 5 }}>
                                                            {matchData && matchData.challenger2_country && (
                                                                <CircleFlag
                                                                    country={getCountryName(matchData.challenger2_country) || 'Unknown'}
                                                                    size="medium"
                                                                />
                                                            )}
                                                            <Text
                                                                style={{
                                                                    fontSize: 20,
                                                                    textAlign: 'left',
                                                                    whiteSpace: 'nowrap',
                                                                    fontWeight: 'bold',
                                                                    textTransform: 'uppercase',
                                                                    marginRight: 10,
                                                                }}
                                                            >
                                                                {matchData.challenger2_name}
                                                            </Text>
                                                        </div>
                                                        {sets &&
                                                            sets.map((set, index) => {
                                                                return (
                                                                    <div key={index} style={{ padding: 5, width: 30, textAlign: 'center' }}>
                                                                        <Text
                                                                            style={{
                                                                                fontSize: 18,
                                                                                color: set.challenger2_score === set.challenger2_race_to && '#86d068',
                                                                                fontWeight:
                                                                                    set.challenger2_score === set.challenger2_race_to ||
                                                                                    set.challenger2_score > set.challenger1_score
                                                                                        ? 'bold'
                                                                                        : 'normal',
                                                                            }}
                                                                        >
                                                                            {set.challenger2_score}
                                                                        </Text>
                                                                    </div>
                                                                );
                                                            })}
                                                        <div
                                                            style={{
                                                                width: 30,
                                                                paddingTop: 5,
                                                                paddingBottom: 5,
                                                                paddingLeft: 10,
                                                                paddingRight: 10,
                                                                backgroundColor: 'rgba(0,0,0,0.8)',
                                                                borderRadius: 10,
                                                            }}
                                                        >
                                                            <Text
                                                                style={{
                                                                    fontSize: 18,
                                                                    color:
                                                                        totalSetsWon('challenger2', matchData.tournament_match_sets) >
                                                                            totalSetsWon('challenger1', matchData.tournament_match_sets) && '#86d068',
                                                                    fontWeight: 'bold',
                                                                }}
                                                            >
                                                                {totalSetsWon('challenger2', matchData.tournament_match_sets) || 0}
                                                            </Text>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form>
                                )}
                            />
                        </div>
                    </React.Fragment>
                );
            }}
        </Query>
    );
}
